import "components/jiffy/checkout-order-details/checkout-order-details";
import "./claim-form.scss";

export default () => {
  const $selectElement = document.getElementById("request_claim_reason");
  if (!$selectElement) return;

  const $customReasonContainer = document.getElementById("custom_reason_container");
  const $customReasonInput = document.getElementById("custom_reason_input");

  $selectElement.addEventListener("change", () => {
    if ($selectElement.value === "Other") {
      $customReasonContainer.style.display = "block";
      $customReasonInput.required = true;
    } else {
      $customReasonContainer.style.display = "none";
      $customReasonInput.required = false;
    }
  });
};
